/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class EffectSprite extends Phaser.GameObjects.Sprite {
  constructor(scene) {
    super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, 'glow_2');
    scene.add.existing(this);

    this.scene = scene;
  }

  reset(startX, startY, animation) {
    if (animation === 'glow') {
      this.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'glow_2');
      this.play('glowAnim');
    }
    if (animation === 'explosion1') {
      this.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'explosion_0');
      this.play('explosion1Anim');
    }
    if (animation === 'explosion2') {
      this.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'explosion2_0');
      this.play('explosion2Anim');
    }
    if (animation === 'explosion3') {
      this.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'explosion3_0');
      this.play('explosion3Anim');
    }
    if (animation === 'smoke') {
      this.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'smoke1_1');
      this.play('smokeAnim');
    }

    this.setVisible(true);

    this.workingWidth = this.getBounds().width;
    this.workingHeight = this.getBounds().height;
    this.x = startX;
    this.y = startY;
  };
}